var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasItems()
    ? _c("div", { staticClass: "header-cart" }, [
        _c(
          "div",
          { staticClass: "level-item level-right" },
          [
            _c(
              "router-link",
              {
                staticClass: "button button--cart",
                attrs: { to: "/checkout" }
              },
              [
                _c("mq-layout", { attrs: { mq: "desktop" } }, [
                  _c("span", { staticClass: "item-count" }, [
                    _c("span", { staticClass: "item-count-text" }, [
                      _vm._v("View Cart (" + _vm._s(_vm.itemCount) + ")")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("mq-layout", { attrs: { mq: ["mobile", "tablet"] } }, [
                  _c("div", { staticClass: "item-count-background" }, [
                    _c("span", { staticClass: "item-count" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.itemCount) +
                          "\n\t\t\t\t\t"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("BaseIcon", {
                  attrs: {
                    classNames: { icon: true },
                    icon: "cartIcon",
                    size: "lg"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-254574cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254574cf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/HeaderCart.vue
// module id = null
// module chunks = 